import { HomeThermometerIcon } from './HomeThermometerIcon';

/**
 * author: Tim Grelka
 * id 833E3484-3C40-4F98-96CB-537FB6225711
 * name home-thermometer
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-thermometer.svg
 * tags
 * - Home Automation 
 */
export const HomeTemperatureIcon = HomeThermometerIcon;
export default HomeTemperatureIcon